export default {
    offices: ( state ) => {
        return state.offices;
    }
}